import React from 'react';

/**
 * TaskChecklistIcon
 * Custom clipboard with checkmark icon matching user specification.
 * Supports standard react-icon properties (size, className, color, style).
 */
export default function TaskChecklistIcon({ size, className = '', color = 'currentColor', style = {}, ...props }) {
  const width = size ? (typeof size === 'number' ? `${size}px` : size) : '1em';
  const height = size ? (typeof size === 'number' ? `${size}px` : size) : '1em';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 512 512"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={`shrink-0 inline-block align-middle ${className}`}
      style={{ color, ...style }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M 182 0 H 330 A 24 24 0 0 1 354 24 V 40 H 409 A 44 44 0 0 1 453 84 V 467 A 44 44 0 0 1 409 511 H 103 A 44 44 0 0 1 59 467 V 84 A 44 44 0 0 1 103 40 H 158 V 24 A 24 24 0 0 1 182 0 Z M 208 39 H 304 A 10 10 0 0 1 314 49 V 69 A 10 10 0 0 1 304 79 H 208 A 10 10 0 0 1 198 69 V 49 A 10 10 0 0 1 208 39 Z M 158 118 V 80 H 113 A 14 14 0 0 0 99 94 V 457 A 14 14 0 0 0 113 471 H 399 A 14 14 0 0 0 413 457 V 94 A 14 14 0 0 0 399 80 H 354 V 118 H 158 Z"
      />
      <path
        d="M 178 300 L 230 352 L 334 248"
        fill="none"
        stroke="currentColor"
        strokeWidth="40"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
